module.exports = Em.Route.extend({
    userOrganizations: Em.inject.service(),

    organization: Em.computed.alias('userOrganizations.activeOrganization'),

    model: function(params) {
        var organization = this.get('organization')
        var isSourceZervant = organization.get('isSourceZervant')

        if (isSourceZervant) {
            return null
        }

        var quote = this.store.getById('quote', params.quote_id)
        if (quote) {
            return quote
        }
        return this.store.find('quote', { organization: this.modelFor('organization').id, id: params.quote_id })
            .then(function(quotes) {
                return quotes.objectAt(0)
            })
    }
})
